import axios from "../../../../../axios";
import Cookies from "js-cookie";

// services/jobService.js
// Author: Harshada Bhavsar (19/7/2025)
// API: Created Job Opening for Employee
export const getCreatedJobs = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/GetCreatedJobs", {
    token,
  });
};

// services/jobService.js
// Author:  Sanket Raut 23-july-2025
// API: Get Publish Jobs by JobUID
export const getPublishJobsByUID = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/PublishJob", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar (22/7/2025)
// API: Get Job Details for Employee
export const getJobDetails = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/GetJobDetails", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 18-08-2025
// API: Assign Job To Employee
export const assignJobToEmployee = async (jobUID, employeeCode, token) => {
  return await axios.post("/api/Jobs/AssignJobToEmployee", {
    token,
    jobUID,
    employeeCode,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 18-08-2025
// API: Assign Job To Consultant
export const assignJobToConsultant = async (jobUID, consultantCode, token) => {
  return await axios.post("/api/Jobs/AssignJobToConsultant", {
    token,
    jobUID,
    consultantCode,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 03-02-2026
// API: UnAssign Job To Employee
export const unassignJobToEmployee = async (jobUID, employeeCode, token) => {
  return await axios.post("/api/Jobs/UnAssignJobToEmployee", {
    token,
    jobUID,
    employeeCode,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 10-11-2025
// API: Get Sent Candidates For Jobs 
export const updateJobOpening = async (jobData) => {
  const token = Cookies.get("employeeToken");
  const formData = new FormData();

  Object.keys(jobData).forEach((key) => {
    if (key !== "jobDescription" && key !== "jobInterviewers") {
      formData.append(key, jobData[key] ?? "");
    }
  });

  if (Array.isArray(jobData.jobInterviewers)) {
    jobData.jobInterviewers.forEach((interviewer, index) => {
      formData.append(
        `JobInterviewers[${index}].InterviewerCode`,
        interviewer.interviewerCode,
      );
      formData.append(
        `JobInterviewers[${index}].InterviewSequence`,
        interviewer.interviewSequence,
      );
    });
  }

  if (jobData.jobDescription) {
    formData.append("JobDescription", jobData.jobDescription);
  }

  formData.append("Token", token);

  return axios.post("/api/Jobs/Employee/UpdateJobOpening", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 11-11-2025
//  Fetch job interviewers by JobUID
export const getJobInterviewers = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/GetJobInterviewers", {
    token,
    jobUID,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 12-11-2025
//  delete job interviewers by JobUID
export const deleteJobInterviewer = async (jobUID, interviewerCode) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Jobs/Employee/DeleteJobInterviewer", {
    token,
    jobUID,
    interviewerCode,
  });
};

// services/jobService.js
// Author: Harshada Bhavsar 06-03-2026
// API: UnAssign Job To Employee
export const unassignJobToConsultant = async (jobUID, consultantCode, token) => {
  return await axios.post("/api/Jobs/UnAssignJobToConsultant", {
    token,
    jobUID,
    consultantCode,
  });
};

